// src/components/landing/SiteHeader.jsx
import React, { useEffect, useState } from "react";
import "../../sass/landing/header.scss";
import Marca from "../../assets/landing/marca-escura.webp";
import { scrollToSection } from "./scroll";

const LINKS = [
  { id: "beneficios", label: "Como ajuda" },
  { id: "como-funciona", label: "Dia a dia" },
  { id: "planos", label: "Planos" },
  { id: "faq", label: "Dúvidas" },
];

const SiteHeader = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (event, id) => {
    event.preventDefault();
    scrollToSection(id);
  };

  return (
    <header className={`lp-header ${scrolled ? "is-scrolled" : ""}`}>
      <div className="lp-shell lp-header__inner">
        <a
          href="#hero"
          className="lp-header__brand"
          onClick={(event) => goTo(event, "hero")}
          aria-label="PsyAssist Pro, voltar ao início"
        >
          <img src={Marca} alt="" width="36" height="36" />
          <span>
            PsyAssist <em>Pro</em>
          </span>
        </a>

        <nav className="lp-header__nav" aria-label="Navegação principal">
          {LINKS.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(event) => goTo(event, link.id)}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="lp-header__actions">
          <a href="/login" className="lp-header__login">
            Entrar
          </a>
          <a
            href="#planos"
            className="lp-header__cta"
            onClick={(event) => goTo(event, "planos")}
          >
            <span className="lp-header__cta-long">Testar 7 dias grátis</span>
            <span className="lp-header__cta-short">7 dias grátis</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
